/* eslint-disable no-prototype-builtins */

/* eslint-disable prefer-template */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../components/Box';
import { Button } from '../../../../components/Buttons';
import { EditSquare, TimesSquare, View, Edit, Trash } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { Well } from '../../../../components/Well';
import { selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { performAction } from '../../actions';
import { REQUEST_KANBAN_BOARD_COLUMN_CELLS, REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { BaseCellComp } from '../BaseCellComp';
import { Cell } from '../Cell';
import { CellButton, CellButtons } from '../CellButton';
import { assignVehicleTasks, setVehicleProperty, fetchVehicle, setVehicleProperties } from '../../../Vehicles/actions';
import { Label } from '../../../Vehicles/components/VehicleCounterLabel';
import { VehiclePropertyLoadable } from '../../../Vehicles/components/VehiclePropertyLoadable';
import { WithVehicleProperty } from '../../../Vehicles/components/WithVehicleProperty';
import { selectVehicleProperty, selectVehicle } from '../../../Vehicles/selectors';
import { REQUEST_USER } from '../../../Users/constants';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { selectUser } from '../../../Users/selectors';
import { List, Row } from '../../../../components/List';
import { fetchUser } from '../../../Users/actions';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { DocumentsList } from '../../../Documents/components/documentsList';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import NotificationComponent from '../../../../containers/App/Components/Notification/Notification';
import cn from 'classnames';
import styles from './WS_Default.module.css';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';
import { COUNTER_MAP } from './CounterMap';

import { KanbanVehicleRemarks } from '../../components/KanbanVehicleRemarks';
import { getRemarkType } from '../helpers/getRemarkType';
import { selectUserId, selectWork } from '../../../Api/selectors';
import { FormField } from '../../../../components/FormFields';
import { getPropByName } from '../../../../utils/props';
import { COLOR_PRIMARY_1 } from '../../../../vars';


let todaydate = new Date().toISOString();

//change this for values of counters
const ranges = {
  MediumSeaGreen: [1, 2],
  DarkOrange: [3, 5],
  Crimson: [6, Infinity],
};

const usercolors = {
  MediumSeaGreen: [0],
  RoyalBlue: [1],
  DarkOrange: [2],
  Crimson: [3],
  Chartreuse: [4],
  DeepPink: [5],
  Goldenrod: [6],
  Teal: [7],
};

dayjs.extend(customParseFormat);
const Container = styled.div`
  font-size: 14px;
  .card-title {
    font-size: 14px;
    text-transform: uppercase;
  }

  .option-buttons .button {
    width: 100%;
  }
  .red-text {
    color: red;
  }

  .manco-list > div {
    margin: 12px 0;
  }
  .triple {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 12px 0;

    .btn-check:checked + .btn {
      background-color: var(--color-new-secondary);
      border-color: var(--color-new-secondary);
      color: #fff; /* optioneel: tekst wit voor contrast */
    }
    .btn-check:not(:checked) + .btn {
      border-color: var(--color-new-primary);
      color: var(--color-new-primary);
    }

    transition: opacity 0.2s;
    .check {
      transition: opacity 0.2s;
      display: inline-block;
      width: 24px;
      height: 24px;
      border: 1px solid ${COLOR_PRIMARY_1};
      color: ${COLOR_PRIMARY_1};
      text-align: center;
      font-size: 21px;
      line-height: 20px;
    }
    &.triple-0 {
      .check {
      }
    }
    &.triple-1 {
      .check {
        border: 1px solid #3bb78e;
        color: #3bb78e;
      }
    }
    &.triple-2 {
      .check {
        border: 1px solid red;
        text-align: center;
        color: red;
      }
    }
    &.disabled {
      opacity: 0.4;
      .check {
        opacity: 0;
      }
    }
    @media (max-width: 425px) {
      font-size: 12px;
    }
  }
`;

export const TaskAssignable = {
  Teun: '0',
  Arjan: '1',
  Len: '2',
  Stefan: '3',
  Overig: '4',
};

export const TasksAssignableOptions = _.map(TaskAssignable, (value, name) => ({ label: name, value: value }));

const STATE = {
  approve: false,
  regplate_code: '',
  isOpenAddModal: false,
  tasksRemarks: [],
  newRemarkText: '',
  editableRemark: null,
  buttonClicked: false,
};

/* eslint-disable react/prefer-stateless-function */
class WS_PlannableComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetch();
    const { vehicle } = this.props;

    if (vehicle && vehicle.tasksRemarks) {
      try {
        const parsedTasksRemarks = JSON.parse(vehicle.tasksRemarks);
        this.setState({ tasksRemarks: parsedTasksRemarks || [] });
      } catch (error) {
        console.error('Error parsing tasksRemarks JSON:', error);
        // Handle the error gracefully, e.g., set default state or display a message
      }
    }

    if (env.clientId === AppClientId.HILTERMANN) {
      this.setState({
        [this.supplierProps.SUPLIER]: getPropByName(this.props.vehicle, this.supplierProps.SUPLIER),
        HILT_parkingspot: getPropByName(this.props.vehicle, 'HILT_parkingspot'),
      });
    }

  }

  componentDidUpdate(prevProps) {
    const { vehicle } = this.props;

    if (
      (prevProps.vehicle?.id !== vehicle?.id || prevProps.vehicle?.tasksRemarks !== vehicle?.tasksRemarks) &&
      vehicle &&
      vehicle.tasksRemarks
    ) {
      try {
        const parsedTasksRemarks = JSON.parse(vehicle.tasksRemarks);
        this.setState({ tasksRemarks: parsedTasksRemarks || [] });
      } catch (error) {
        console.error('Error parsing tasksRemarks JSON:', error);
        // Handle the error gracefully, e.g., set default state or display a message
      }
    }
    if (prevProps.vehicle != this.props.vehicle && env.clientId === AppClientId.HILTERMANN) {
      this.setState({
        [this.supplierProps.SUPLIER]: getPropByName(this.props.vehicle, this.supplierProps.SUPLIER),
      });
    }
  }

  get supplierProps() {
    return {
  
    };
  }

  get remarkDate() {
    return dayjs(new Date(Date.now())).format('DD-MM-YYYY HH:mm');
  }

  get doubleCheckProps() {
    let props = [this.supplierProps.SUPLIER_INFORMED];
    return props;
  }
  renderDoubleCheck(name) {
    let val = this.propertyValue(name);
    let state = (val === undefined || val === 0) ? null : (val == 1 ? 1 : 0);

    return (
      <HBox vCenter key={name}>
        <div
          className={`triple triple-${state} ${this.props.work ? 'disabled' : ''}`}
          // onClick={() => this.props.setProperty(name, state == 0 ? 1 : 0)}
        >
          <div className="label">{this.lbl(`vehicle.property.${name}`)}</div>
          <VehiclePropertyLoadable name={name}>
            <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`} // uniek per veld
                id={`btnradio1-${name}`}
                autoComplete="off"
                checked={state == 1}
                onChange={() => this.props.setProperty(name, 1)}
              />
              <label className={`btn btn-outline-primary ${state == 1 ? 'active' : ''}`} htmlFor={`btnradio1-${name}`}>
                Todo
              </label>

              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`}
                id={`btnradio2-${name}`}
                autoComplete="off"
                checked={state == 0}
                onChange={() => this.props.setProperty(name, 0)}
              />
              <label className={`btn btn-outline-primary ${state == 0 ? 'active' : ''}`} htmlFor={`btnradio2-${name}`}>
                Gereed
              </label>
       
            </div>
            {/*<div className="check">{state == 0 ? '-' : '+'}</div>*/}
          </VehiclePropertyLoadable>
        </div>
      </HBox>
    );
  }

  renderEditableVehicleFields() {
    return (
      <VBox>
        {[this.supplierProps.SUPLIER].map(prop => {
          return (
            <HBox key={prop} vCenter gap={'8px'}>
              {this.lbl(`vehicle.property.${prop}`)}
              <VehiclePropertyLoadable name={prop}>
                <div className={styles.buttonLabel}>
                  <div className={styles.labelCompany}>
                    <input
                      className="form-control"
                      type={prop}
                      value={this.state[prop]}
                      onChange={this.onInputChange.bind(this)}
                      name={prop}
                      key={prop}
                      onBlur={() => {
                        this.state[prop] && this.props.setProperty(this.vehicle.id, prop, this.state[prop]);
                        console.log('onBlur', this.state[prop]);
                      }}
                    />
                  </div>
                  <div className={styles.decoratorLabel}>€</div>
                </div>
              </VehiclePropertyLoadable>
            </HBox>
          );
        })}
      </VBox>
    );
  }

  propertyValue(name) {
    return this.props.vehicle[name];
  }

  onSave() {
    const remark = {
      id: Date.now(),
      text: this.state.newRemarkText.trim(),
      name: getPropByName(this.props.loggedUser, 'name'),
      surname: getPropByName(this.props.loggedUser, 'surname'),
      date: this.remarkDate,
      nameTask: this.props.payload.task_name,
    };

    const updatedTasksRemarks = [...this.state.tasksRemarks, remark];
    this.props.setRemark(this.vehicle.id, JSON.stringify(updatedTasksRemarks), () => {
      this.setState(prevState => ({
        ...STATE,
        approve: prevState.approve,
        tasksRemarks: prevState.tasksRemarks,
      }));
      this.props.refreshBoards();
    });
  }

  onEdit(remarkId) {
    const remark = {
      id: remarkId,
      text: this.state.newRemarkText,
      name: getPropByName(this.props.loggedUser, 'name'),
      surname: getPropByName(this.props.loggedUser, 'surname'),
      date: this.remarkDate,
      nameTask: this.props.payload.task_name,
    };

    const tasksRemarks = this.state.tasksRemarks?.filter(remark => remark?.id != remarkId);
    const updatedtasksRemarks = [...tasksRemarks, remark];

    this.props.setRemark(this.vehicle.id, JSON.stringify(updatedtasksRemarks), () => {
      this.setState(prevState => ({
        ...STATE,
        approve: prevState.approve,
        tasksRemarks: prevState.tasksRemarks,
      }));
      this.props.refreshBoards();
    });
  }

  onDelete = remarkId => {
    const updatedTasksRemarks = this.state.tasksRemarks.filter(remark => remark.id !== remarkId);
    this.props.setRemark(this.vehicle.id, JSON.stringify(updatedTasksRemarks));
  };

  reset = () => {
    this.setState({ ...STATE, tasksRemarks: this.state.tasksRemarks });
  };

  renderInitials(name, surname) {
    return (
      <HBox left vCenter>
        <HBox className="initials-wrapper" vCenter left>
          <strong>{name[0]?.toUpperCase()}</strong>
          <strong>{surname[0]?.toUpperCase()}</strong>
        </HBox>
        &nbsp;
        <strong>{name ?? ''}</strong>
        &nbsp;
        <strong>{surname ?? ''}</strong>
      </HBox>
    );
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  getTaskStatus() {
    let name = this.props.payload?.task_name;
    return this.vehicle[name];
  }

  taskAssignedTo({ task_assigned_to, usercolors }) {
    const assignedToName = Object.keys(TaskAssignable).find(key => TaskAssignable[key] === String(task_assigned_to));

    return (
      <Label count={task_assigned_to} ranges={usercolors}>
        {assignedToName}
      </Label>
    );
  }

  getStatusName() {
    let name = this.props.payload?.task_name;
    if (!name) return '';
    return this.lbl('vehicle.plannable.status.' + this.vehicle[name]);
  }

  get counterTaskName() {
    let countertaskname;
    const task_name = this.props.payload?.task_name;
    if (COUNTER_MAP.hasOwnProperty(task_name)) {
      countertaskname = this.vehicle?.[COUNTER_MAP[task_name]];
    } else {
      countertaskname = '-';
    }

    return countertaskname;
  }

  getLabelColor() {
    switch (this.getTaskStatus()) {
      case '1':
      case '3':
        return 'green';
      case '2':
        return 'yellow';
    }
  }

  update(status) {
    let properties = [];
    if (status == '0') {
      properties?.push({
        propertyName: this.props.payload.task_name + '_done',
        propertyValue: '1',
      });

      properties?.push({
        propertyName: this.props.payload.task_name + '_done_date',
        propertyValue: todaydate,
      });

      if (this.props.payload.task_name == 'task_restyle') {
        let extra_cost_restyle_plans = this.vehicle.extra_cost_restyle_plans
          ? Number(this.vehicle?.extra_cost_restyle_plans)
          : '0';
        extra_cost_restyle_plans = extra_cost_restyle_plans + 45;

        properties?.push({
          propertyName: 'extra_cost_restyle_plans',
          propertyValue: extra_cost_restyle_plans,
        });
        console.log('extra_cost_restyle_plans', extra_cost_restyle_plans);

        properties?.push({
          propertyName: 'WS_TASK_DONE',
          propertyValue: '1',
        });
        properties?.push({
          propertyName: 'task_final_inspection',
          propertyValue: '0',
        });
      }
    }

    if (status == '3') {
      properties?.push({
        propertyName: this.props.payload.task_name + '_planned_extern_date',
        propertyValue: todaydate,
      });
    }

    if (status == '2') {
      properties?.push({
        propertyName: this.props.payload.task_name + '_planned_intern_date',
        propertyValue: todaydate,
      });
    }
    this.props.updateVehicleProperties(this.props.vehicle?.id, properties);

    this.props.update(this.vehicle.id, status, () => this.setState({ approve: null }));
  }
  renderAddModal() {
    return (
      <ModalComponent
        className={styles.modal}
        title={this.state.editableRemark ? this.lbl('info.tasksremarks.edit') : this.lbl('info.tasksremarks.add')}
        onClose={() => this.setState({ isOpenAddModal: false })}
      >
        <FormField>
          <textarea
            className="form-control"
            value={this.state.newRemarkText}
            onChange={e => this.setState({ newRemarkText: e.target?.value })}
          />
        </FormField>
        <div className="d-flex gap-2 mt-2 justify-content-center">
          <ButtonComponent
            style={'ButtonSoftEdit'}
            disabled={this.props.work}
            onClick={this.state.editableRemark ? () => this.onEdit(this.state.editableRemark) : this.onSave.bind(this)}
          >
            {this.state.editableRemark ? this.lbl('confirm') : this.lbl('add')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  renderRemarks() {
    const { tasksRemarks } = this.state;
    const filteredRemarks = tasksRemarks.filter(remark => remark.nameTask);
    return filteredRemarks.map(remark => (
      <Row key={remark?.id}>
        <div className={styles.remarkCard}>
          <HBox className="gap-2" vCenter right>
            <ButtonComponent
              style={'ButtonSoftEdit'}
              size={'btn-sm'}
              onClick={() =>
                this.setState({ isOpenAddModal: true, editableRemark: remark?.id, newRemarkText: remark?.text })
              }
            >
              <Edit />
            </ButtonComponent>
            <ButtonComponent style={'ButtonSoftDelete'} size={'btn-sm'} onClick={() => this.onDelete(remark?.id)}>
              <Trash />
            </ButtonComponent>
          </HBox>
          <VBox className="remark" vCenter>
            {remark?.name && remark?.surname && this.renderInitials(remark?.name, remark?.surname)}
            <div className={styles.remarkText}>
              <h6>{remark?.text}</h6>
            </div>
          </VBox>
          <HBox>
            <div>{remark?.nameTask}</div>
            <div>{remark?.date}</div>
          </HBox>
        </div>
      </Row>
    ));
  }

  renderApprove() {
    if (this.props.work) return <Loader small />;
    const task_name = this.props.payload?.task_name;
    const assigned_to = task_name + '_assigned_to';
    const vehicle = this?.vehicle; // assuming vehicle is a prop

    const task_assigned_to = vehicle?.[assigned_to];
    // console.log('task_assigned_to', task_assigned_to);
    if (!this.state.approve) return null;

    if (this.state.loading) {
      this._t = this.timeout(this.props.onChange, 1000, this._t);
    }

    const documents = vehicle.documents;
    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.props.action.label}>
        <Container>
          <WithVehicle loader vehicle_id={this.vehicle.id}>
            <VehicleHeader
              plannable
              task_name={this.props.payload?.task_name}
              vehicle={this.vehicle}
              label={this.getStatusName()}
              labelColor={this.getLabelColor()}
            />
            <Well>{this.props.column.label}</Well>
            <Well>{this.vehicle?.fix_damages_details}
            {env.clientId === AppClientId.HILTERMANN && (
              this.vehicle?.HILT_repair_remark)}
            </Well>
            
            
            {this.props.payload?.task_name === 'task_hartstad' && (
              <Well>
                <>
                  * Altijd moet er een vloermatten-set in liggen, een set wat er al in ligt en kapot is vervangen <br />
                  * Geen onderhoudsmeldingen , ook niet binnen de eerste 10.000 km. <br />
                  * Vloeistoffen vol: olie, ruitenvloeistof, koelvloeistof, etc.
                  <br />
                  * Volle Tank
                  <br />
                  * Minimaal 6 maand apk, korter dan 6 maand APK dan nieuwe APK regelen <br />
                  * Banden minimaal 4 mm, anders vervangen
                  <br />
                  * 2 sleutels, minder als 1 sleutel moet er een nieuwe geregeld worden
                  <br />
                  * 0-beurt waar nodig altijd bij inzet nieuwe auto
                  <br />
                </>
              </Well>
            )}
            <VehiclePropertyLoadable
              propertyName={this.props.payload.task_name}
              vehicleId={this.vehicle.id}
              hideChildrenOnLoad
            >
              <div className={styles.buttonGrid}>
                {env.clientId !== AppClientId.AUTOHUISSALLAND && (
                  <>
                    {env.clientId !== AppClientId.HILTERMANN && ( <ButtonComponent
                      style={'ButtonSoftPrimary'}
                      disabled={this.getTaskStatus() == '0'}
                      onClick={() => this.update('0')}
                    >
                      {this.lbl('vehicle.plannable.status.0')}
                    </ButtonComponent>
                    )}
                    <ButtonComponent
                      style={'ButtonSoftPrimary'}
                      disabled={this.getTaskStatus() == '2'}
                      onClick={() => this.update('2')}
                    >
                      {this.lbl('vehicle.plannable.status.2')}
                    </ButtonComponent>
                    <ButtonComponent
                      style={'ButtonSoftPrimary'}
                      disabled={this.getTaskStatus() == '1'}
                      onClick={() => this.update('1')}
                    >
                      {this.lbl('vehicle.plannable.status.1')}
                    </ButtonComponent>
                    <ButtonComponent
                      style={'ButtonSoftPrimary'}
                      disabled={this.getTaskStatus() == '3'}
                      onClick={() => this.update('3')}
                    >
                      {this.lbl('vehicle.plannable.status.3')}
                    </ButtonComponent>
                  </>
                )}
              </div>




              {env.clientId === AppClientId.AUTOHUISSALLAND && (
                <>
                  {this.state.isOpenAddModal && this.renderAddModal(this.state.isEdit)}
                  <HBox>
                    <h2 className="card-title mb-0 text-muted">{this.lbl('info.kanbantasksremarks.title')}</h2>
                    <ButtonComponent
                      style={'ButtonSoftPrimary'}
                      size={'btn-sm'}
                      onClick={() => this.setState({ isOpenAddModal: true })}
                    >
                      {this.lbl('info.kanbantasksremarks.add')}
                    </ButtonComponent>
                  </HBox>
                  <List>{this.renderRemarks()}</List>

                  {/* <div className="mb-2 mt-4">
                    <h2 className="card-title mb-2 text-muted">{this.lbl('vehicle.info.documents.title')}</h2>
                    <DocumentsList
                      entityId={vehicle.id}
                      entityType="vehicle"
                      items={documents}
                      nameTask={this.props.payload.task_name}
                    />
                  </div> */}

                  <div style={{ maxWidth: '600px', textAlign: 'center' }}>
                    {console.log('task_assigned_to', task_assigned_to)}
                    {TasksAssignableOptions.map(a => (
                      <Button
                        primary={a.value == this.state.selected || task_assigned_to == a.value}
                        key={a.label}
                        onClick={this.setStateFn({ selected: a.value })}
                      >
                        {a.label.replace(/\_/g, ' ')}
                      </Button>
                    ))}
                  </div>
                </>
              )}

            </VehiclePropertyLoadable>
            {/* {this.getTaskStatus() == '3' && env.clientId === AppClientId.HILTERMANN && (
              <VBox className="manco-list" key="manco">
                {this.renderEditableVehicleFields()}

                {this.doubleCheckProps.map(name => this.renderDoubleCheck(name))}
              </VBox>
            )} */}

            <div className="mt-2 d-flex gap-2">
              {/* <PerformActionButton action={this.props.action} target={this.vehicle} onChange={this.reset.bind(this)} /> */}
              <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
                {this.lbl('cancel')}
              </ButtonComponent>
              <ButtonComponent
                style="ButtonSoftEdit"
                disabled={this.state.buttonClicked}
                onClick={() => {
                  // Handle the case where the text-field is empty, you can show an error message or perform some other action.
                  this.props.assign(this.state.selected, this.reset.bind(this));
                }}
              >
                {this.lbl('add')}
              </ButtonComponent>
            </div>
          </WithVehicle>
        </Container>
      </ModalComponent>
    );
  }

  render() {
    const task_name = this.props.payload?.task_name;
    const vehicle = { ...this.vehicle, [task_name]: this.props.taskPropertyValue };
    const countertaskname = this.counterTaskName;
    console.log(task_name);
    const TASK_REMARK_TYPE = task_name?.replace('task_', '');

    return (
      <Cell className={styles.cell}>
        <Container>
          <WithVehicleProperty
            propertyValue={this.vehicle[task_name]}
            vehicleId={vehicle.id}
            propertyName={task_name}
            alt={<VehicleHeader vehicle={vehicle} />}
          >
            <VehicleHeader
              task_name={this.props.payload?.task_name}
              plannable
              vehicle={vehicle}
              label={this.getStatusName()}
              labelColor={this.getLabelColor()}
            />
            {this.vehicle.dont_fix_damages == '1' && (
              <span className="red-text">{this.lbl('kanbanboards.cell.schades_niet_repareren')}</span>
            )}
            {this.vehicle.sell_without_license_plate == '1' && !this.vehicle.regplate ? (
              <span className="red-text">{this.lbl('kanbanboards.cell.sell_without_license_plate')}</span>
            ) : null}
            <Label count={countertaskname} ranges={ranges}>
              {countertaskname}
            </Label>

            <CellButtons>
              {this.props.cell.busy ? (
                <Loader small />
              ) : (
                <>
                  {this.props.workRemarks ? (
                    <Loader small />
                  ) : (
                    <KanbanVehicleRemarks
                      readOnly
                      taskName={TASK_REMARK_TYPE}
                      kanbanBoardLabel={this.props.board?.label}
                      vehicleId={this.vehicle.id}
                      loggedUserId={this.props.loggedInUserId}
                    />
                  )}
                  <CellButton
                    onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
                  >
                    <View />
                  </CellButton>
                </>
              )}
            </CellButtons>
            {this.renderApprove()}
          </WithVehicleProperty>
        </Container>
      </Cell>
    );
  }
}

WS_PlannableComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loggedUser: selectUser(ownProps?.loggedUserId),
    taskPropertyValue: selectVehicleProperty(ownProps.cell.vehicle.id, ownProps.payload?.task_name),
    work: selectWorks([
      `${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`,
      REQUEST_USER,
      `${REQUEST_VEHICLE_PROPERTY_UPDATE}-tasksRemarks`,
      REQUEST_VEHICLE_PROPERTY_UPDATE + ownProps.vehicle?.id,
    ]),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
  });
function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch: async () => {
      // Dispatch an action to indicate the start of loading
      dispatch({ type: 'FETCH_START' });

      try {
        // Perform the fetch operation
        await dispatch(fetchUser(ownProps?.loggedUserId));
      } catch (error) {
        // Handle any errors during the fetch
        console.error('Error fetching user:', error);
      } finally {
        // Dispatch an action to indicate loading is complete
        dispatch({ type: 'FETCH_END' });
      }
    },

    assign(id, callback) {
      dispatch(
        assignVehicleTasks(ownProps.cell.vehicle.id, `${id}`, true, ownProps.payload?.task_name, () => {
          dispatch(refreshBoards());
          callback();
        }),
      );
    },
    refreshBoards: () => dispatch(refreshBoards()),

    setRemark(vehicle_id, dto, callback) {
      dispatch(setVehicleProperty(vehicle_id, 'tasksRemarks', dto, callback));
    },
    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
    setProperty(vehicle_id, name, value) {
      dispatch(setVehicleProperty(vehicle_id, name, value));
    },
    update(vehicle_id, status, callback) {
      dispatch(
        setVehicleProperty(vehicle_id, ownProps.payload.task_name, status, result => {
          callback?.();
          ownProps.onChange();
        }),
      );
    },
    updateVehicleProperties(vehicleId, properties, callback) {
      dispatch(setVehicleProperties(vehicleId, properties, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WS_Plannable = compose(withConnect, withRouter)(WS_PlannableComp);
